import { FC, ReactElement, useEffect, useRef, useState } from "react";
import { fetchAsync, postAsync, postWithoutSign } from "../services/ApiHandler";
import { PromptHintSet } from "../model/PromptHintSet";
import { PromptHint } from "../model/PromptHint";
import toast, { Toaster } from "react-hot-toast";

export const SubscriptionPuchasePage: FC = () => {
  async function subscribe(planName: string){
    var param = {
      planName: planName,
    };

    const response = await postAsync<string>("Subscription/Subscribe", param);
    if(response.code === 1) {
      toast.success("購入しました");
      return;
    } else {
      toast.error(response.message ?? "");
    }
  }
  
  function buildPlanArea(planId: string, planName: string, price: number, maxCount: number){
    return <>
      <div className="text-center border mr-4 px-2 py-2 rounded">
        <div className="text-bold text-xl">{planName}</div>
        <div>{`価格: ${price} 円`}</div>
        <div>{`上限枚数: ${maxCount} 枚`}</div>
        <button className="mt-4 border w-full" onClick={(e) => subscribe(planId)}>購入</button>
      </div>
    </>
  }

  return <>
    <Toaster />
    <div className="text-center mt-12">
      <div className="flex justify-center">
        { buildPlanArea("light", "ライト", 1800, 150)}
        { buildPlanArea("standard", "スタンダート", 2800, 420)}
        { buildPlanArea("advance", "アドバンス", 5600, 870)}
        { buildPlanArea("pro", "プロ", 18000, 3000)}
      </div>
    </div>
  </>;
}